import DocumentList from "components/portal/documents/DocumentsList";
import UserDocumentsReportingView from "components/portal/reporting/UserDocumentsReportingView";
import FatigueAssessmentReport from "components/portal/reporting/FatigueAssessmentReportingView";
import LoginHistoryReport from "components/portal/reporting/LoginHistoryReportingView";
import { Viewer } from "components/portal/pdf/Viewer";
import UnderConstruction from "components/UnderConstruction";
import Home from 'pages/Home';
import SigninOidc from "pages/SignInOIDC";
import SignoutOidc from "pages/SignOutOIDC";
import SilentAuth from "pages/SilentAuth";
import UserProfile from "pages/UserProfile";
import DocumentSearch from "components/portal/documents/search/DocumentSearch";
import Login from "pages/Login";
import Debug from 'pages/DebugInfo';
import { GeneralAdministrationModule } from 'components/portal/administration/general-administration-data';
import { AllDocumentRoutes } from 'components/ui/DocumentRules';
import { allFatigueAssessmentRoutes } from 'components/ui/FatigueAssessmentRules';
import { UserManagementModule } from "components/portal/administration/user-management-data";
import React from "react";
import NoAccess from "../pages/NoAccess";
import { allDrivingExemptionRoutes } from "../components/portal/drivingExemption/DrivingExemptionRules";
import GNHExemptionReport from "../components/portal/reporting/GNHExemptionReportingView";
import D2DocumentReport from "../components/portal/reporting/D2DocumentReportingView";
import { allTrainEventRecordRoutes } from "../components/portal/OperationalForms/OperationalFormsRules";
import { allUserApprovalsRoutes } from "../components/portal/userApprovals/UserApprovalsRules";
import { allTakeFiveRoutes } from "../components/portal/takeFive/TakeFiveRules";
import { TakeFiveReport } from "../components/portal/reporting/TakeFiveReportingView";
import TrainEventReport from "../components/portal/reporting/TrainEventReportingView";

// TODO define colors once in css
export interface IRouteConfig {
    breadCrumb?: string,
    color?: string,
    unProtected?: boolean,
    endTrail?: boolean,
    permission?: string,
    path?: string,
    element?: React.JSX.Element
}



export const homePath = "/";

export const RouteList: IRouteConfig[] =
    [{
        unProtected: true,
        path: '/signin-oidc',
        element: <SigninOidc />,
        breadCrumb: "SignIn",
    },
    {
        unProtected: true,
        path: '/login',
        element: <Login />,
        breadCrumb: "Home",
    },
    {
        unProtected: true,
        path: '/signout-oidc',
        element: <SignoutOidc />,
        breadCrumb: "SignOut",
    },
    {
        unProtected: true,
        path: '/silent-auth',
        element: <SilentAuth />,
        breadCrumb: "Silent Auth",
    },
    {
        path: homePath,
        element: <Home />,
        breadCrumb: "Home",
    },
    {
        path: '/signin-aad',
        element: <Home />,
        breadCrumb: "Home",
    },
    {
        path: UserManagementModule.url,
        breadCrumb: UserManagementModule.title,
        element: <UserManagementModule.component />,
    },
    {
        path: GeneralAdministrationModule.url,
        breadCrumb: "General Administration",
        element: <GeneralAdministrationModule.component />,
    },
    {
        path: GeneralAdministrationModule.url + "/:module",
        breadCrumb: "General Administration",
        element: <GeneralAdministrationModule.component />,
    },
    {
        path: "/reporting/user-document",
        breadCrumb: "User / Document reporting",
        permission: "web.admin.user.reporting",
        element: <UserDocumentsReportingView />,
    },
    {
        path: "/reporting/fatigue-assessment",
        breadCrumb: "Fatigue Assessment reporting",
        permission: "web.admin.fatigue-assessment.shift-summary-dashboard",
        element: <FatigueAssessmentReport />,
    },
    {
        path: "/reporting/gnh-exemption",
        breadCrumb: "GNH Exemption reporting",
        permission: "web.admin.gnh-exemption.exemption-request-dashboard",
        element: <GNHExemptionReport />,
    },
    {
        path: "/reporting/d2-document-update",
        breadCrumb: "D2 Document reporting",
        permission: "web.admin.d2-document.d2-imported-document",
        element: <D2DocumentReport />,
    },
    {
        path: "/reporting/take-five",
        breadCrumb: "Take 5 reporting",
        element: <TakeFiveReport />,        
    },
    {
        path: "/reporting/train-event-record",
        breadCrumb: "Train Event reporting",
        element: <TrainEventReport />,
    },
    {
        path: "/reporting/login-history",
        breadCrumb: "Login History reporting",
        permission: "web.admin.user.reporting",
        element: <LoginHistoryReport />,
    },
    {
        path: "/search",
        element: <DocumentSearch />,
        breadCrumb: "Search",
        endTrail: true,
    },
    {
        path: "/search/:searchTerm",
        element: <DocumentSearch />,
        breadCrumb: "Search",
        endTrail: true,
    },
    {
        path: "/pdf/view/:mode/:documentId/module?/:module?/page?/:page?/search?/:search?",
        element: <Viewer />,
        breadCrumb: "PDF Viewer",
        endTrail: true,
    },
    {
        path: "/underconstruction",
        element: <UnderConstruction />,
        breadCrumb: "Under Construction",
    },
    {
        path: "/test",
        element: <Debug />,
        breadCrumb: "Test page",
    },
    {
        path: "/userprofile",
        element: <UserProfile />,
        breadCrumb: "My profile details",
    },
    {
        path: "/noaccess",
        element: <NoAccess />,
        breadCrumb: "No Access",
    }
    ]
        .concat(AllDocumentRoutes(DocumentList))
        .concat(allFatigueAssessmentRoutes())
        .concat(allDrivingExemptionRoutes())
        .concat(allTakeFiveRoutes())
        .concat(allTrainEventRecordRoutes())
        .concat(allUserApprovalsRoutes())